export enum KindIcons {
  brand = "lightbulb",
  danger = "exclamationMarkTriangle",
  info = "information",
  success = "checkCircle",
  warning = "exclamationMarkTriangle",
}
